<template>
    <NuxtLayout name="main">
        <module-navigations />
        <div class="search-box container">
            <div class="search-aside">
                <div class="search-aside-container">
                    <div class="search-aside-title color-1 font-bold">
                        {{ $t("FilterBy") }}
                    </div>
                    <div class="search-aside-group">
                        <UiCheckboxGroup v-model="database">
                            <template v-for="(value, index) in cards">
                                <ui-checkbox :value="value.key">
                                    <div class="ellipsis">{{ value.title }}</div>
                                </ui-checkbox>
                            </template>
                        </UiCheckboxGroup>
                    </div>
                </div>
            </div>
            <div class="search-tablls">
                <template v-for="(value, key) in cards">
                    <div class="search-default search-mutation" v-if="database.includes(value.key) || !database.length" :key="key">
                        <!-- 卡片头部 -->
                        <div class="search-module-header" v-if="data">
                            <div class="search-module-card card-header" :class="{ disabled: !value.data.count }">
                                <ProjectRoute :to="next(value.data, value.route)" target="_self">
                                    <div class="card-header-row">
                                        <h2 class="card-name title-4 font-bold">{{ value.title }}</h2>
                                        <div class="card-number card-disease-number title-5 font-bold">{{ value.data?.count }}</div>
                                    </div>
                                </ProjectRoute>
                            </div>
                        </div>
                        <!-- 卡片列表 -->
                        <div class="search-module-list" v-if="data">
                            <div class="search-mutation-body search-module-card card-list">
                                <div class="card-list-body" v-if="value.data?.data?.length">
                                    <!-- 基因|疾病|模型 表格 -->
                                    <SearchDiagram
                                        v-if="value.key != 'Mutation' && value.key != 'Tool'"
                                        v-on="ons.diagram"
                                        :hover="{ spacing: 24 }"
                                        ref="table"
                                        :mode="value.key"
                                        :data="value.data?.data.slice(0, 5)"
                                        :option="value.option"
                                        :placeholder="$t('NoData')">
                                        <!-- //* 疾病 **/ -->
                                        <template #name="{ data }">
                                            <div class="ellipsis">{{ data.full_name }}</div>
                                        </template>

                                        <template #gene="{ data }">
                                            <div class="ellipsis" v-html="data.rel_gene_name"></div>
                                        </template>

                                        <template #rare="{ data }">
                                            <span style="color: #ce2424" v-if="data.is_rare">✔</span>
                                        </template>

                                        <template #inheritance="{ data }">
                                            <div class="inheritance">
                                                <div
                                                    :class="[value.color_type]"
                                                    v-for="(value, key) in data.inheritance_tag"
                                                    :key="key"
                                                    :title="value.value">
                                                    {{ value.tag }}
                                                </div>
                                            </div>
                                        </template>

                                        <!-- //* 基因 -->
                                        <template #categories="{ data }">
                                            <div class="categories">
                                                <UiTooltip class="categorie" direction="bottom" v-for="value in data.categories_icon">
                                                    <img :src="value.icon" alt="" />
                                                    <template #content>
                                                        {{ value.value }}
                                                    </template>
                                                </UiTooltip>
                                            </div>
                                        </template>
                                        <template #species="{ data }">
                                            <div class="align">
                                                <ui-icon class="icon" :name="useSpeciesIconKey(data.taxonomy_id)" />
                                                <div class="context">{{ `(${data.taxonomy_name})` }}</div>
                                            </div>
                                        </template>
                                        <template #gene_name="{ data }">
                                            <div class="ellipsis align">
                                                <div class="ellipsis">
                                                    <span v-if="!data.gene_name && !data.gene_full_name">--</span>
                                                    <span v-else-if="!data.gene_name">{{ data.gene_full_name }}</span>
                                                    <span v-else-if="!data.gene_full_name" class="active">{{ data.gene_name }}</span>
                                                    <template v-else>
                                                        <span class="active">{{ data.gene_name }}</span>
                                                        <span>&nbsp;-&nbsp;{{ data.gene_full_name }}</span>
                                                    </template>
                                                </div>
                                            </div>
                                        </template>

                                        <!-- //* 模型 -->
                                        <template #model_name="{ data }">
                                            <div class="name">
                                                <span class="ellipsis active" v-html="data.name"></span>
                                                <ui-icon v-if="data.tag" class="hot" name="hot" />
                                            </div>
                                        </template>

                                        <template #alias="{ data }">
                                            <div class="ellipsis" v-html="data.alias"></div>
                                        </template>

                                        <template #strain="{ data }">
                                            <div class="ellipsis">{{ data.strain }}</div>
                                        </template>

                                        <template #disease="{ data }">
                                            <div class="ellipsis">{{ data.related_disease }}</div>
                                        </template>
                                    </SearchDiagram>

                                    <!-- 突变表格 -->
                                    <ui-table2 :option="value.option" :data="value.data?.data.slice(0, 5)" v-else-if="value.key == 'Mutation'">
                                        <template #gene="{ data }">
                                            <ProjectRoute
                                                :class="css_normalize.assets"
                                                :to="{ name: 'Gene', params: { id: data.gene_id }, query: { keyword: route.query.keyword } }"
                                                v-html="data.gene" />
                                        </template>
                                        <!-- 碱基改变 -->
                                        <template #mutation_transcript="{ data }">
                                            <template v-if="!data.mutation_transcript">--</template>
                                            <template v-else-if="!data.skip">
                                                {{ data.mutation_transcript }}
                                            </template>
                                            <project-route
                                                v-else
                                                :class="css_normalize.assets"
                                                :to="{
                                                    name: 'BioVariantResult',
                                                    query: { id: data.transcript, mode: '', keyword: data.mutation_transcript },
                                                    params: { id: data.gene_id },
                                                }">
                                                <span> {{ data.mutation_transcript }}</span>
                                            </project-route>
                                        </template>

                                        <template #mutation_protein="{ data }">
                                            <template v-if="!data.mutation_protein">--</template>
                                            <template v-else-if="!data.skip">{{ data.mutation_protein }}</template>
                                            <project-route
                                                v-else
                                                :class="css_normalize.assets"
                                                :to="{
                                                    name: 'BioVariantResult',
                                                    query: { id: data.transcript, mode: 'codon', keyword: data.mutation_protein },
                                                    params: { id: data.gene_id },
                                                }">
                                                {{ data.mutation_protein }}
                                            </project-route>
                                        </template>

                                        <template #references="{ data }">
                                            {{ data.references }}
                                            <ProjectRoute :to="data.references_link"><ui-icon class="icon-export" name="export" /></ProjectRoute>
                                        </template>
                                        <template #transcript="{ data }">
                                            <template v-if="!data.transcript">--</template>
                                            <template v-else-if="!data.skip">{{ data.transcript }}</template>
                                            <template v-else>
                                                <project-route
                                                    :class="css_normalize.assets"
                                                    :to="{
                                                        name: 'BioVariantResult',
                                                        query: { id: data.transcript, mode: 'codon' },
                                                        params: { id: data.gene_id },
                                                    }">
                                                    <span>{{ data.transcript }}</span>
                                                    <ui-tooltip>
                                                        <span class="mrna_label" v-if="data.default || data.default_clinical">
                                                            {{ (data.default && "M") || (data.default_clinical && "MP") }}
                                                        </span>
                                                        <template #content>
                                                            {{ (data.default && "MANE Select") || (data.default_clinical && "MANE Plus Clinical ") }}
                                                        </template>
                                                    </ui-tooltip>
                                                </project-route>
                                            </template>
                                        </template>
                                        <template #clinical="{ data }">
                                            {{ data.clinical }}
                                            <project-route
                                                v-if="data.clinvar"
                                                :to="`https://www.ncbi.nlm.nih.gov/clinvar/variation/${data.clinvar}/`">
                                                <ui-icon class="icon-export" name="export" />
                                            </project-route>
                                        </template>

                                        <template #disease_qty="{ data }">
                                            <span>{{ data.related_diseases.length }}</span>
                                            <ui-tooltip class-extra-name="diseases" direction="bottom" align="start">
                                                <span class="add" v-if="data.related_diseases.length">+</span>
                                                <template #content>
                                                    <span class="color-1 font-bold">{{ $t("RelatedDiseases") }}：</span>
                                                    <div class="disease_items">
                                                        <template v-for="(value, key) in data.related_diseases">
                                                            <project-route class="disease" :to="{ name: 'Disease', params: { id: value.id } }">
                                                                {{ value.name }}
                                                            </project-route>
                                                        </template>
                                                    </div>
                                                </template>
                                            </ui-tooltip>
                                        </template>
                                        <template #transcriptId="{ data }">
                                            <template v-if="!data.transcript_id">--</template>
                                            <template v-else-if="!data.skip">{{ data.transcript_id }}</template>
                                            <template v-else>
                                                <project-route
                                                    :class="css_normalize.assets"
                                                    :to="{
                                                        name: 'BioVariantResult',
                                                        query: { id: data.transcript_id, mode: 'codon' },
                                                        params: { id: data.gene_id },
                                                    }">
                                                    <span>{{ data.transcript_id }}</span>
                                                    <ui-tooltip>
                                                        <span class="mrna_label" v-if="data.default || data.default_clinical">
                                                            {{ (data.default && "M") || (data.default_clinical && "MP") }}
                                                        </span>
                                                        <template #content>
                                                            {{ (data.default && "MANE Select") || (data.default_clinical && "MANE Plus Clinical ") }}
                                                        </template>
                                                    </ui-tooltip>
                                                </project-route>
                                            </template>
                                        </template>
                                    </ui-table2>

                                    <!-- AI生信工具表格 -->
                                    <ui-table2 :option="value.option" :data="value.data?.data.slice(0, 5)" v-else-if="value.key == 'Tool'">
                                        <template #name="{ data }">
                                            <div v-html="data.name"></div>
                                        </template>
                                        <template #operate="{ data }">
                                            <ProjectRoute :to="data.link" target="_blank" v-if="data.link"
                                                ><ui-button style="--uioption-button-radius: 999px; --uisize-font-size: 14px" size="small">
                                                    {{ $t("View") }}
                                                </ui-button></ProjectRoute
                                            >
                                            <div v-else>--</div>
                                        </template>
                                    </ui-table2>

                                    <ProjectRoute :to="next(value.data, value.route)" target="_self" class="card-list-more">
                                        {{ value.more }}
                                    </ProjectRoute>
                                </div>
                                <div v-else class="card-noresult">
                                    <div class="card-noresult-text">
                                        <div class="card-noresult-text">
                                            <i18n-t v-if="value.key != 'Mutation'" keypath="SearchNoResult" scope="global">
                                                <template #keyword>
                                                    {{ route.query.keyword }}
                                                </template>
                                            </i18n-t>

                                            <i18n-t v-else keypath="MutationNoResult" scope="global">
                                                <template #keyword>
                                                    <span class="ellipsis">{{ route.query.keyword }}</span>
                                                </template>
                                                <template #pathogenicity>
                                                    <ProjectRoute :class="css_normalize.assets" :to="{ name: 'Pathogenicity' }" target="_blank"
                                                        >Pathogenic Predictor</ProjectRoute
                                                    >
                                                </template>
                                                <template #rna_splicer>
                                                    <ProjectRoute :class="css_normalize.assets" :to="{ name: 'RnaSplicer' }" target="_blank"
                                                        >RNA Splicer</ProjectRoute
                                                    >
                                                </template>
                                                <template #variant_viewer>
                                                    <ProjectRoute :class="css_normalize.assets" :to="{ name: 'BioVariant' }" target="_blank"
                                                        >Mutation Direct</ProjectRoute
                                                    >
                                                </template>
                                            </i18n-t>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库引入
import { $loading, UiIcon, UiTable2, UiCheckboxGroup, UiCheckbox, UiTooltip, UiButton } from "various-ui";
//* 公共组件
import { SearchDiagram } from "@/components/visualizations";
//* 私有公共组件
import ModuleNavigations from "../components/navigations/index.vue";
//* 工具函数
import { Formats } from "@/assets/js";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css_normalize from "@/assets/style/src/index.module.less";

//* 获取route
const route = useRoute();

//* 组合函数
const { refs, watchs, methods, ons } = useComposable();
const { data, cards, database } = refs;
const { next } = methods;
//* 组件挂载完成调用接口获取数据
onMounted(() => {
    //* 开启Loading, 如果在3毫秒内关闭则不会出现
    $loading.open({ delay: 300, message: "" });
    //* 请求接口获取数据
    api.frontend("/api/search", {
        data: { keyword: Formats.query(route.query.keyword) },
        method: "POST",
        success: (response) => {
            data.value = response;
            methods.initCards(response);
        },
        finally: () => {
            $loading.close();
        },
    });
});

//* 组件卸载前, 移除watch和loading
onBeforeUnmount(() => {
    watchs.stopHandler && watchs.stopHandler();
    $loading.close();
});
</script>

<style lang="less" scoped>
@import "./style/variable.less";
@import "./style/index.less";
</style>
